var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTouchIdPersonal = function SvgTouchIdPersonal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12 13.143c.714 3.55 4 6.5 7.653 5.723"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M16.1 21.952c-3.6-.909-5.899-4.007-6.678-5.76-1.573-3.54-.278-6.25 1.93-6.585 1.326-.202 3.131.205 4.148 2.936 1.012 2.718 2.834 3.29 4 3 2.11-.524 3.222-2.581 1.957-5.936-1.11-2.946-4.386-6.601-10.106-6.492a9.3 9.3 0 0 0-4.065 1.034m11.617 8.322C17.765 7.452 14 5.874 10.852 6.361c-2.265.35-5.548 2.37-5.548 6.658 0 1.703.473 2.81 1.447 4.786s.195 2.82-.501 3.145-1.725-.021-2.393-.89c-1.113-1.448-1.59-3.03-1.827-4.234-.693-3.506.18-6.625 1.93-8.896"
  })));
};
export default SvgTouchIdPersonal;